export default __webpack_public_path__ + "static/media/lydian-trading-academy-coming_soon.38e6fbfd.png";